export const createColumn = (props) => ({
  flex: 1,
  editable: false,
  sortable: false,
  resizable: false,
  suppressHeaderMenuButton: true,
  headerClass: "header-center",
  ...props,
});

/**
 * @desc Allow to format the currency
 * @example
 * currencyFormatter(1000000, "T", 0) => 1 000 000 T
 * currencyFormatter(1000000, "T", 2) => 1 000 000,00 T
 *
 * @param {Number | String} currency
 * @param {String} sign
 * @param {Number} decimals
 * @returns {String}
 */
export function currencyFormatter(currency, sign, decimals = 0) {
  if (currency === undefined || sign === undefined) return 0;

  const value = Number(currency);
  if (isNaN(value)) return 0;

  const withDecimals = Math.abs(value).toFixed(decimals);
  const isNegative = value < 0;

  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = withDecimals?.split(".");

  // Format the integer part with spaces as thousands separators
  const formattedInteger = integerPart?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  let formatted = isNegative ? "-" + formattedInteger : formattedInteger;

  if (decimals > 0 && decimalPart) {
    formatted += "," + decimalPart;
  }

  return formatted + " " + sign;
}
